import clsx from 'clsx'
import { type ClientLinkDestination, ClientLinks } from './client-links'

export interface ClientCardProps {
  name: string
  schoolName?: string | null
  grade?: string | null
  age?: number | null
  cartwheelHref?: string | null
  healthieHref?: string | null
  kustomerHref?: string | null
  className?: string
  onResourceClick?: (destination: ClientLinkDestination) => void
}

export function ClientCard({
  name,
  schoolName,
  grade,
  age,
  cartwheelHref,
  healthieHref,
  kustomerHref,
  className,
  onResourceClick,
}: ClientCardProps) {
  const gradeAndAge = formatGradeAndAge(grade, age)

  return (
    <div
      className={clsx(
        'overflow-hidden rounded-lg border border-sand bg-white p-6 shadow-sm',
        className
      )}
    >
      <div className="flex flex-col gap-4">
        <div>
          <div className="flex h-6 w-full items-center justify-between gap-2">
            <h3 className="min-w-0 truncate text-base font-semibold leading-[1.5] text-charcoal">
              {name}
            </h3>
            <span className="shrink-0 rounded-lg bg-lavender-25 px-2 py-0.5 text-xs font-semibold leading-[1.5] text-indigo">
              Client
            </span>
          </div>
          <div className="text-sm leading-[1.5] text-charcoal-50">
            <p className="truncate">{schoolName ?? 'School unavailable'}</p>
            {gradeAndAge && <p className="truncate">{gradeAndAge}</p>}
          </div>
        </div>
        <ClientLinks
          cartwheelHref={cartwheelHref}
          healthieHref={healthieHref}
          kustomerHref={kustomerHref}
          onResourceClick={onResourceClick}
        />
      </div>
    </div>
  )
}

function formatGradeAndAge(grade?: string | null, age?: number | null): string | null {
  const details = [grade, age == null ? null : `${age} years old`].filter(Boolean)
  return details.length > 0 ? details.join(', ') : null
}
